module.exports = __webpack_public_path__ + "static/media/ic_claim_assist_fisdom.86ef2605.svg";